import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentService, environment, HelperService, UserService } from "@mypxplat/xplat/core";

import { CourseDetailBaseComponent } from "@mypxplat/xplat/features";
import { AppService, SeoService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-course-detail",
  templateUrl: "course-detail.component.html",
  standalone: false,
})
export class CourseDetailComponent extends CourseDetailBaseComponent implements OnInit {
  constructor(
    userService: UserService,
    public activatedRoute: ActivatedRoute,
    public contentService: ContentService,
    public helperService: HelperService,
    public appService: AppService,
    private _router: Router,
    private _seo: SeoService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.contentService.getEducationData().subscribe((result) => {
      this.courseId = this.activatedRoute.snapshot.params["id"];
      this.course = this.contentService.courseMap[this.courseId];
      this._applySeo();
    });
  }

  private _applySeo() {
    if (!this.course) return;
    const description = (this.course.description || "").replace(/<[^>]*>/g, "");
    const trimmed = description ? description.substring(0, 200).trim() : "A course on MyFender.";
    const ogImage = this.course.image || undefined;
    const canonical = `https://my.fender.com/learn/course/${this.course.id}`;
    this._seo.setPageMeta({
      title: `${this.course.title} | MyFender Learn`,
      description: trimmed,
      canonical,
      ogImage,
      ogType: "article",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "Course",
        name: this.course.title,
        description: trimmed,
        image: ogImage,
        url: canonical,
        provider: {
          "@type": "Organization",
          name: "MyFender",
          url: "https://my.fender.com",
        },
      },
    });
  }

  pin(enroll = true) {
    if (!this.user) {
      this.appService.redirectToConnect(true, false);
      return;
    }
    let args: any = {
      user_id: this.user.id,
      learn_group_id: this.course.id,
      enrolled: enroll,
      date_started: new Date(),
    };

    this.contentService.saveUserLearnGroupData(this.course.id, args).subscribe({
      next: (result) => {},
      error: (error) => {
        this.appService.alertError(error);
      },
    });
  }

  upgrade() {
    this._router.navigate(["/onboarding"], { queryParams: { subscribeOnly: true } });
  }
}
